import { render } from "./EventDetails.vue?vue&type=template&id=ede41ed0&scoped=true"
import script from "./EventDetails.vue?vue&type=script&lang=js"
export * from "./EventDetails.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-ede41ed0"

export default script